module.exports = __webpack_public_path__ + "static/media/lil stuart.d72edd59.ttf";